import type { SxProps } from 'components/base/system/style';
import type { Theme } from 'components/base/system/theme';

export const rootStyles: SxProps<Theme> = {
  py: 0.25,
};

export const textGroupStyles: SxProps<Theme> = {
  minWidth: 0,
};

export const titleStyles: SxProps<Theme> = {
  fontWeight: 600,
  m: 0,
  lineHeight: 1.35,
};

export const messageStyles: SxProps<Theme> = {
  m: 0,
  lineHeight: 1.45,
};
